import Layout from '../components/Layout';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const AffiliateDisclosure = () => {
  return (
    <Layout>
      {/* Hero */}
      <section data-testid="disclosure-hero" className="py-20 md:py-32 bg-[#F5F5F0]">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#1C1C1C] leading-tight mb-6">
            Affiliate Disclosure
          </h1>
          <p className="text-base md:text-lg text-[#374151] leading-relaxed">
            Transparency is important to us. Here's everything you need to know about how we recommend products and earn revenue.
          </p>
        </div>
      </section>

      {/* Disclosure Content */}
      <section data-testid="disclosure-content" className="py-20 md:py-32 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="prose prose-lg max-w-none space-y-8">
            <div className="p-8 bg-[#F2EBE3] border-l-4 border-[#3A4D39]">
              <p className="text-[#374151] leading-relaxed font-medium mb-0">
                This website contains affiliate links. This means that if you click on a product link and make a purchase, I may receive a small commission at no extra cost to you.
              </p>
            </div>

            <div className="space-y-4 text-[#374151] leading-relaxed">
              <p>
                I only recommend products that I genuinely believe may be helpful and relevant based on research, personal experience, or general product information.
              </p>
              
              <p>
                These commissions help support the maintenance and content creation of this website.
              </p>
              
              <p className="font-semibold text-[#1C1C1C]">
                As an Amazon Associate, I earn from qualifying purchases.
              </p>
            </div>

            <hr className="border-[#E5E5E5]" />

            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#1C1C1C] mb-4">
                What This Means For You
              </h2>
              <ul className="space-y-3 text-[#374151]">
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 bg-[#3A4D39] rounded-full mt-2.5 flex-shrink-0" />
                  <span>The price you pay is exactly the same whether you use our affiliate link or not.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 bg-[#3A4D39] rounded-full mt-2.5 flex-shrink-0" />
                  <span>We never let affiliate relationships influence our recommendations. Our content is created independently.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 bg-[#3A4D39] rounded-full mt-2.5 flex-shrink-0" />
                  <span>We do not accept payment for placement or positive reviews.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 bg-[#3A4D39] rounded-full mt-2.5 flex-shrink-0" />
                  <span>Using our links is a simple way to support our work if you find our content helpful.</span>
                </li>
              </ul>
            </div>

            <hr className="border-[#E5E5E5]" />

            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#1C1C1C] mb-4">
                Our Commitment to You
              </h2>
              <p className="text-[#374151] leading-relaxed">
                We believe in honest, transparent recommendations. Every product featured on this site has been selected because we genuinely believe it may be beneficial based on our research and analysis—not because of affiliate potential.
              </p>
              <p className="text-[#374151] leading-relaxed mt-4">
                If you ever have questions about our recommendations or affiliate relationships, please don't hesitate to reach out.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-[#F5F5F0]">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <h3 className="font-heading text-2xl font-semibold text-[#1C1C1C] mb-4">
            Ready to explore our guides?
          </h3>
          <Link 
            to="/"
            data-testid="disclosure-cta-home"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#3A4D39] text-white text-sm font-medium tracking-wide uppercase transition-all duration-300 hover:bg-[#2A3D29]"
          >
            Back to Home
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default AffiliateDisclosure;
